import { render, staticRenderFns } from "./PromptShippingSales.vue?vue&type=template&id=ecbd51fc&scoped=true&"
import script from "./PromptShippingSales.vue?vue&type=script&lang=js&"
export * from "./PromptShippingSales.vue?vue&type=script&lang=js&"
import style0 from "./PromptShippingSales.vue?vue&type=style&index=0&id=ecbd51fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbd51fc",
  null
  
)

export default component.exports